import React from 'react';
import { Divider, Grid, Card as MuiCard } from '@mui/material';
import { Box, Typography } from 'components/index';

interface SimpleListCardProps {
  icon?: JSX.Element;
  heading: string;
  headerAction?: JSX.Element;
  list: string[];
  itemsPerRow?: 1 | 2 | 3 | 4;
  backgroundColor?: string;
}

const SimpleListCard: React.FC<SimpleListCardProps> = ({ icon, heading, headerAction, list, itemsPerRow = 3, backgroundColor }) => {
  const gridWidth = 12 / itemsPerRow;

  return (
    <MuiCard elevation={3} sx={{ p: 2, width: '100%', height: '100%', backgroundColor: backgroundColor }}>
      <Box display='flex' alignItems='center' justifyContent={'space-between'}>
        <Box display='flex' alignItems='center'>
          {icon}
          <Typography variant='h6' color='primary' sx={{ ml: 1, mb: 0 }}>
            {heading}
          </Typography>
        </Box>
        <Box alignSelf={'flex-end'}>{headerAction ?? null}</Box>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={3}>
        {list.map(item => {
          return (
            <Grid size={{ xs: gridWidth }} key={item}>
              <Typography variant='button' color='text' fontWeight='regular' textTransform='capitalize'>
                {item}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    </MuiCard>
  );
};

export default SimpleListCard;
